import React from 'react'

import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start'
	}
}))

const ReactivationDialog = (props) => {
	const classes = useStyles()

	let { isShown, setIsShown, confirmActivation } = props

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => setIsShown(false)}
			PaperProps={{
				style: {
					minWidth: '448px',
					maxWidth: '448px',
					width: '448px'
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 24
				}}>
				REACTIVATE CONTACT
			</DialogTitle>
			<DialogContent>
				<Typography
					variant="body2"
					style={{
						marginBottom: 24
					}}>
					Once reactivated, the client will be able to log into the client app with their last set
					password. Are you sure you’d like to continue?
				</Typography>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="contained" onClick={() => confirmActivation()} color="secondary">
					REACTIVATE CONTACT
				</Button>
				<Button variant="outlined" onClick={() => setIsShown(false)} color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default ReactivationDialog
